var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithTextBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167,
    height: 51,
    viewBox: "0 0 167 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1.135.187h10.163v14.81H1.135z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.355.187H10.52v14.81H.355z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 .546h14.549v10.347H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M1.134 1.253h10.164v14.81H1.134z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M0 50.955h166.073V.276H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC708",
    d: "M38.405 4.29l-6.508 12.614c.57.478 1.093 1.01 1.553 1.583l12.391-6.626a25.35 25.35 0 0 0-7.436-7.57"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.984 .089)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC708",
    d: "M3.82 14.997L11.298 2.95A24.282 24.282 0 0 0 1.135.187l.56 14.232c.727.119 1.44.314 2.125.578",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC708",
    d: "M49.787 24.368a25.454 25.454 0 0 0-2.716-10.348l-11.832 7.614c.26.698.448 1.423.565 2.162l13.983.572zM3.947 11.86l12.39 6.626c.461-.573.983-1.104 1.554-1.582L11.383 4.291a25.35 25.35 0 0 0-7.436 7.57"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.15 .089)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC708",
    d: "M9.959 14.42L10.52.186A24.262 24.262 0 0 0 .355 2.95l7.479 12.047c.683-.265 1.397-.46 2.125-.578",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.475)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC708",
    d: "M2.717.546A25.399 25.399 0 0 0 0 10.893l13.983-.572c.117-.74.307-1.464.566-2.163L2.717.546z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F3",
    d: "M38.405 46.937a25.33 25.33 0 0 0 7.436-7.569l-12.39-6.626c-.465.579-.987 1.11-1.554 1.583l6.508 12.612zM11.383 46.937l6.508-12.612a11.152 11.152 0 0 1-1.553-1.583l-12.39 6.626a25.314 25.314 0 0 0 7.435 7.569"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.984 34.892)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F3",
    d: "M1.695 1.831l-.561 14.232A24.29 24.29 0 0 0 11.298 13.3L3.82 1.253c-.684.265-1.398.46-2.125.578",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F3",
    d: "M20.984 36.146l-7.479 12.047a24.257 24.257 0 0 0 10.165 2.761l-.561-14.23a10.742 10.742 0 0 1-2.125-.578M47.07 37.21a25.454 25.454 0 0 0 2.718-10.346l-13.984.567c-.117.74-.305 1.467-.565 2.165L47.07 37.21zM0 26.863A25.399 25.399 0 0 0 2.717 37.21l11.832-7.615a11.243 11.243 0 0 1-.566-2.163L0 26.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#345275",
    d: "M72.57 30.591c-.758-.494-1.765-.922-3.022-1.286-1.257-.363-2.801-.807-4.63-1.33-1.113-.32-1.964-.655-2.549-1.005-.586-.348-.878-.813-.878-1.396 0-.668.292-1.14.878-1.417.585-.276 1.45-.415 2.593-.415 1.2 0 2.092.226 2.679.677.585.451.95 1.171 1.093 2.16h5.357c-.144-2.21-.915-3.942-2.315-5.192-1.4-1.251-3.614-1.877-6.643-1.877-1.657 0-3.057.168-4.2.502-1.142.335-2.072.778-2.785 1.331-.715.553-1.237 1.193-1.565 1.92a5.547 5.547 0 0 0-.493 2.311c0 .902.123 1.718.365 2.444.243.727.714 1.395 1.414 2.007.7.61 1.678 1.171 2.935 1.68 1.258.509 2.916.996 4.972 1.462 1.143.26 1.994.566 2.55.914.558.35.836.917.836 1.703 0 .697-.378 1.214-1.136 1.548-.757.335-1.665.502-2.72.502-1.259 0-2.28-.277-3.066-.828-.786-.553-1.178-1.339-1.178-2.358h-5.744c.03 1.136.28 2.16.751 3.077a6.854 6.854 0 0 0 2.013 2.357c.872.653 1.923 1.155 3.151 1.504 1.228.35 2.6.522 4.115.522 3.086 0 5.413-.631 6.986-1.896 1.571-1.265 2.356-2.857 2.356-4.778 0-1.249-.164-2.247-.491-2.987-.33-.742-.872-1.36-1.63-1.856M90.353 32.468c0 1.425-.364 2.595-1.094 3.512-.727.916-1.806 1.374-3.234 1.374-2.373 0-3.557-1.338-3.557-4.014V20.077h-5.572v14.137c0 1.191.178 2.268.535 3.227.357.961.85 1.79 1.478 2.487a6.425 6.425 0 0 0 2.252 1.615c.87.377 1.835.566 2.891.566 2.943 0 5.128-1.191 6.558-3.577v3.01h5.272V20.078h-5.529v12.391zM116.145 21.343a5.861 5.861 0 0 0-2.207-1.375 8.236 8.236 0 0 0-2.785-.458c-1.715 0-3.114.313-4.2.939-1.087.625-1.957 1.548-2.615 2.77v-3.141h-5.315v21.465h5.573V29.24c0-3.286 1.441-4.93 4.329-4.93 1.314 0 2.242.292 2.785.873.542.582.814 1.701.814 3.36v13.001h5.615V26.665c0-1.163-.179-2.189-.537-3.076-.357-.886-.842-1.636-1.457-2.246M134.695 35.675c-.886 1.206-2.03 1.811-3.428 1.811-1.344 0-2.465-.567-3.365-1.703-.901-1.135-1.35-2.616-1.35-4.449 0-4.654 1.558-6.98 4.671-6.98 3.201 0 4.801 2.21 4.801 6.63 0 1.92-.443 3.485-1.33 4.691m4.715-13.067a7.678 7.678 0 0 0-2.72-2.29c-1.072-.539-2.294-.808-3.665-.808-2.6 0-4.687 1.12-6.257 3.36V12.224h-5.486v29.32h5.357l.042-2.619c1.286 2.124 3.243 3.185 5.873 3.185 1.313 0 2.535-.263 3.663-.785a8.012 8.012 0 0 0 2.893-2.27c.801-.988 1.428-2.195 1.886-3.62.457-1.425.685-3.04.685-4.844 0-1.628-.192-3.119-.577-4.47-.387-1.353-.951-2.524-1.694-3.513"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#345275",
    d: "M144.095 17.504h5.57v-5.28h-5.57zM144.095 41.544h5.57V20.078h-5.57zM166.073 37.168l-4.566.012c-1.142 0-1.964-.372-2.464-1.112-.5-.742-.75-1.797-.75-3.165v-8.812h7.78v-4.014h-7.78v-5.803h-5.485v19.197c0 1.163.156 2.27.472 3.317a7.155 7.155 0 0 0 1.521 2.748c.7.784 1.593 1.41 2.679 1.875 1.085.466 2.4.698 3.942.698.185 0 .37-.003.55-.01h4.101v-4.931z",
    mask: "url(#j)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithTextBlue);
export default __webpack_public_path__ + "static/media/logoWithTextBlue.320093ca4d86b8915966c8b5e921b120.svg";
export { ForwardRef as ReactComponent };